(() => {
  const isDefined = customElements.get('localization-form');

  if (!isDefined) {
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          button: this.querySelector('button'),
          panel: this.querySelector('ul'),
        };

        this.elements.button.addEventListener('click', this.toggleSelector.bind(this));
        this.addEventListener('keyup', this.onKeyUp.bind(this));
      }

      toggleSelector() {
        const expanded = this.elements.button.getAttribute('aria-expanded') === 'true';
        this.elements.button.setAttribute('aria-expanded', String(!expanded));
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.focus();
      }

      onKeyUp(event) {
        if (event.code.toUpperCase() === 'ESCAPE') {
          this.closeSelector();
          this.elements.button.focus();
        }
      }

      closeSelector() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }
    }

    customElements.define('localization-form', LocalizationForm);
  }
})();
